import { IApplicationState } from '../../types/redux';

export function getNearbyNewbuildingsMapUrl(state: IApplicationState) {
  return state.newbuilding.nearbyNewbuildingsMapUrl;
}
